import { render } from "./IreUnitCompValues.vue?vue&type=template&id=529a0624&ts=true"
import script from "./IreUnitCompValues.vue?vue&type=script&lang=ts"
export * from "./IreUnitCompValues.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__